<template>
  <section
    class="section section-shaped section-lg my-0"
    style="padding-top: 20px; height: 100vh;overflow-y: scroll"
  >
    <div class="shape shape-style-1"></div>
    <div class="row" style="max-height: 100px">
      <div class="col-xs" style="width: 100%;">
        <div class="logoHolder">
          <router-link :to="{ name: 'login' }">
            <img
              :src="logoDark || logoLight"
              alt=""
              class="logo"
              style="max-height: 80px"
            />
          </router-link>
        </div>
      </div>
    </div>
    <div class="container pt-lg-md" style="padding-top: 0 !important;">
      <div class="row justify-content-center" style="margin-bottom: 2rem;">
        <div class="col-lg-8">
          <div class="cardHolder" :class="{ bringOut: screens.four }">
            <card
              type="white"
              header-classes="bg-white pb-5"
              body-classes="px-lg-5 py-lg-5"
              class="border-0"
            >
              <template v-if="screens.one">
                <h1 style="text-align: center;font-size: 2rem;margin-top: -2rem;">
                  Getting started
                </h1>
                <p class="lead">Lets start with the basics.</p>

                <form role="form">
                  <label for="firstName">First Name</label>
                  <base-input
                    id="firstName"
                    class="mb-6"
                    placeholder="First Name"
                    addon-left-icon="fa fa-id-badge"
                    v-model="firstName"
                    :valid="fnValid"
                    @change="fnValid = null"
                    name="First Name"
                    title="First Name"
                  >
                  </base-input>
                  <label for="lastName">Last Name</label>
                  <base-input
                    id="lastName"
                    class="mb-6"
                    placeholder="Last Name"
                    addon-left-icon="fa fa-id-badge"
                    v-model="lastName"
                    :valid="lnValid"
                    @change="lnValid = null"
                    name="Last Name"
                  >
                  </base-input>
                  <label for="dateofbirth">Date of Birth</label>
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker
                      id="dateofbirth"
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true, dateFormat: 'm/d/Y' }"
                      class="form-control datepicker"
                      v-model="birthday"
                    >
                    </flat-picker>
                  </base-input>
                  <label for="email">Email Address</label>
                  <small
                    class="danger"
                    style="color: #fb6340;margin-left: 10px"
                    v-if="emailTaken"
                    >Email already in use. This means you have already setup an account with this email address.</small
                  >
                  <small
                    class="danger"
                    style="color: #fb6340; margin-left: 10px"
                    v-if="!validEmailAddress"
                    >Most be a valid email address.</small
                  >
                  <base-input
                    id="email"
                    class="mb-3"
                    placeholder="Email"
                    addon-left-icon="ni ni-email-83"
                    v-model="email"
                    :valid="eValid"
                    @change="
                      eValid = null;
                      validEmailAddress = true;
                      checkEmailAddress();
                    "
                    name="Email Address"
                  >
                  </base-input>
                  <label for="phone">Phone Number (Mobile Phone)</label>
                  <small
                    class="danger"
                    style="color: #fb6340;margin-left: 10px"
                    v-if="phoneTaken"
                    >Phone number already in use. It could be you have an account setup with another email or this phone number was used by another person at some point. Please contact Customer Support if you think this is the case at <a href="tel:+18663001550" >866-300-1550</a></small
                  >
                  <base-input
                    id="phone"
                    class="mb-3"
                    v-mask="'+1 (###) ###-####'"
                    placeholder="Phone Number"
                    addon-left-icon="fa fa-phone"
                    v-model="phone"
                    :valid="pValid"
                    @change="
                      pValid = null;
                      checkPhoneNumber();
                    "
                    name="Phone Number"
                  >
                  </base-input>
                  <p style="font-size: 10px;">
                    By entering in your Mobile Device Number during account registration you are agreeing to the terms and conditions which can be viewed <a style="color: #5e72e4; font-weight:bold" target="_blank" href="https://www.pipelineroi.com/smsterms/">here</a>. 
                    Our privacy policy may be viewed <a style="color: #5e72e4; font-weight:bold" target="_blank" href="https://www.pipelineroi.com/privacy/">here</a>. Message frequency varies and message Data rates may apply. 
                    Once a text message is received you may Text STOP to cease receiving test messages at any time. 
                    Supported carriers: AT&T, Boost Mobile, T-Mobile, Metro by T-Mobile, Verizon Wireless, Sprint, Us cellular, and Virgin Mobile.
                  </p>
                  <base-checkbox alternative v-model="agree">
                    <span
                      >I agree with the
                      <a target="_blank" href="https://www.pipelineroi.com/smsterms/">Terms of Service</a></span
                    >
                  </base-checkbox>
                  <div class="text-center">
                    <base-button
                      type="primary"
                      class="my-4"
                      @click="nextPage"
                      :disable="phoneTaken || emailTaken"
                      name="Next Page"
                      >Next</base-button
                    >
                    <base-progress
                      style="padding: 0;"
                      type="success"
                      :value="0"
                    ></base-progress>
                  </div>
                </form>
              </template>
              <template v-if="screens.pVerifyPage">
                <h1 style="text-align: center;font-size: 2rem;">
                  Phone number verification
                </h1>
                <p class="lead" v-if="!phoneRetry">
                  We just sent you a text with your verification code to
                  <br />{{ phone }}.
                </p>
                <p v-if="!phoneRetry" style="margin-bottom: 0;">
                  <span>Note: </span> This code is only valid for 10 minutes.
                </p>
                <div v-if="!phoneRetry" style="margin-bottom: 2rem;">
                  <p>
                    Didn't receive a code?
                    <span
                      style="color: #5e72e4; font-weight: 600;cursor: pointer;font-size: 14px;"
                      @click="phoneRetry = true"
                      >Try Again</span
                    >
                  </p>
                </div>
                <form action="form" v-if="phoneRetry" style="padding-top: 2rem;">
                  <label for="phone">Phone Number (Mobile Phone)</label>
                  <small
                    class="danger"
                    style="color: #fb6340;margin-left: 10px"
                    v-if="phoneTaken"
                    >Phone number already in use.</small
                  >
                  <base-input
                    id="phone"
                    class="mb-3"
                    v-mask="'+1 (###) ###-####'"
                    placeholder="Phone Number"
                    addon-left-icon="fa fa-phone"
                    v-model="phone"
                    :valid="pValid"
                    @change="
                      pValid = null;
                      checkPhoneNumber();
                    "
                    name="Phone Number"
                  >
                  </base-input>
                  <div class="text-center" v-if="phoneRetry">
                    <base-button
                      type="primary"
                      class="my-4"
                      @click="nextPage"
                      name="Next Page"
                      >Retry</base-button
                    >
                  </div>
                </form>

                <form role="form" v-if="!phoneRetry">
                  <label for="verificationCode">Verification Code</label>
                  <small
                    class="danger"
                    style="color: #fb6340; margin-left: 10px"
                    v-if="passMessage"
                    >{{ passMessage }}</small
                  >
                  <base-input
                    id="verificationCode"
                    class="mb-6"
                    type="text"
                    placeholder="Verification Code"
                    addon-left-icon="fa fa-mobile"
                    v-model="phoneVerifyCode"
                    :valid="phoneVerifyValid"
                    @change="phoneVerifyValid = null"
                    style="margin-bottom: 0px"
                  >
                  </base-input>

                  <div class="text-center">
                    <base-button
                      type="primary"
                      class="my-4"
                      @click="nextPageTwo"
                      >Validate</base-button
                    >
                  </div>
                  <base-progress
                    style="padding: 0;"
                    type="success"
                    :value="25"
                  ></base-progress>
                </form>
              </template>

              <template v-if="screens.two">
                <h1 style="text-align: center;font-size: 2rem;">
                  Account setup
                </h1>
                <p class="lead">
                  Now, lets setup your account. Enter a password.
                </p>
                <p>
                  <span>Note: </span> Password must be at least 8 characters, 1
                  number, 1 capital letter, and 1 non alpha numerical character.
                </p>

                <form role="form">
                  <label for="password">Password</label>
                  <small
                    class="danger"
                    style="color: #fb6340; margin-left: 10px"
                    v-if="passMessage"
                    >{{ passMessage }}</small
                  >
                  <base-input
                    id="password"
                    class="mb-6"
                    type="password"
                    placeholder="Password"
                    addon-left-icon="ni ni-lock-circle-open"
                    v-model="password"
                    :valid="passValid"
                    @keyup="
                      passValid = null;
                      checkPasswordStrength();
                    "
                    style="margin-bottom: 0px"
                  >
                  </base-input>
                  <div
                    class="text-muted font-italic"
                    style="margin-bottom: 1rem"
                  >
                    <small
                      >password requirements:
                      <i
                        class="fa fa-check-circle text-success"
                        v-if="validPassword"
                      ></i>
                      <i
                        class="fa fa-times-circle text-warning"
                        v-if="!validPassword"
                      ></i>
                    </small>
                  </div>
                  <label for="confirmPassword">Confirm Password</label>
                  <small
                    class="danger"
                    style="color: #fb6340; margin-left: 10px"
                    v-if="cPassMessage"
                    >{{ cPassMessage }}</small
                  >
                  <base-input
                    id="confirmPassword"
                    type="password"
                    class="mb-6"
                    placeholder="Confirm Password"
                    addon-left-icon="ni ni-lock-circle-open"
                    v-model="confirmPassword"
                    :valid="cPassValid"
                    @change="
                      cPassValid = null;
                      checkPasswordMatch();
                    "
                  >
                  </base-input>

                  <div class="text-center">
                    <base-button
                      type="primary"
                      class="my-4"
                      @click="accSetupPage"
                      >Next</base-button
                    >
                  </div>
                  <base-progress
                    style="padding: 0;"
                    type="success"
                    :value="75"
                  ></base-progress>
                </form>
              </template>
              <template v-if="screens.three">
                <h1 style="text-align: center;font-size: 2rem;">
                  Account setup
                </h1>
                <p class="lead">
                  Now, lets set your security questions and you are ready to go.
                </p>

                <form role="form">
                  <label for="questionOne">Question One</label>
                  <base-select
                    :options="defaultQuestions"
                    v-model="questions.q1.id"
                  ></base-select>
                  <label for="answerQuestionOne">Answer Question One</label>
                  <base-input
                    id="answerQuestionOne"
                    class="mb-6"
                    placeholder="Answer"
                    addon-left-icon="fa fa-question"
                    v-model="questions.q1.answer"
                    :valid="questions.q1.valid"
                    @change="questions.q1.valid = null"
                  >
                  </base-input>
                  <div class="divider"></div>
                  <label for="questionTwo">Question Two</label>
                  <base-select
                    :options="defaultQuestions"
                    v-model="questions.q2.id"
                  ></base-select>
                  <label for="answerQuestionTwo">Answer Question Two</label>
                  <base-input
                    id="answerQuestionTwo"
                    class="mb-6"
                    placeholder="Answer"
                    addon-left-icon="fa fa-question"
                    v-model="questions.q2.answer"
                    :valid="questions.q2.valid"
                    @change="questions.q2.valid = null"
                  >
                  </base-input>
                  <div class="text-center">
                    <base-button type="success" class="my-4" @click="finish"
                      >Finish</base-button
                    >
                  </div>
                  <base-progress
                    style="padding: 0;"
                    type="success"
                    :value="90"
                  ></base-progress>
                </form>
              </template>
            </card>
          </div>
          <template v-if="screens.four">
            <div class="loginHolder">
              <h1
                style="text-align: center;font-size: 2rem;color:white;font-weight: lighter;"
              >
                Signing in
              </h1>
              <div class="loader" v-if="loading" :class="{ bringIn: loading }">
                <div class="loader-box">
                  <div
                    class="border-1"
                    :class="{ spin1: checking, spin3: !checking }"
                  ></div>
                  <div
                    class="border-2"
                    :class="{ spin2: checking, spin3: !checking }"
                    v-if="checking"
                  ></div>
                  <i v-if="checking" class="ni ni-key-25"></i>
                  <i v-if="!checking" class="ni ni-lock-circle-open unlock"></i>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <modal
      :show.sync="errorModal"
      gradient="warning"
      modal-classes="modal-warning modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Error
      </h6>

      <div class="py-3 text-center">
        <i class="fa fa-exclamation-triangle fa-3x"></i>
        <h4 class="heading mt-4">{{ errorMessage }}</h4>
        <p class="lead">
          Please contact our technical support at 866-300-1550 (Support press 2)
        </p>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="errorModal = false"
        >
          Close
        </base-button>
      </template>
    </modal>
  </section>
</template>
<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  checkEmail,
  checkPhone,
  validEmailAddress,
  getDefaultQuestions,
  validatePassword,
  checkPhoneCode,
  sendPhoneCode,
  newLoanAppUser,
  login,
  getInvitation,
} from "../services/auth";
export default {
  components: { flatPicker },
  data() {
    return {
      screens: {
        one: true,
        two: false,
        three: false,
        four: false,
        pVerifyPage: false,
      },
      phoneRetry: false,
      agree: false,
      aValid: null,
      firstName: "",
      fnValid: null,
      lastName: "",
      lnValid: null,
      email: "",
      eValid: null,
      phone: "",
      pValid: null,
      password: "",
      passValid: null,
      confirmPassword: "",
      cPassValid: null,
      validPassword: true,
      passMessage: null,
      cPassMessage: null,
      emailTaken: false,
      phoneTaken: false,
      phoneChecksOut: false,
      emailChecksOut: false,
      validEmailAddress: true,
      phoneVerifyCode: "",
      phoneVerifyValid: null,
      defaultQuestions: [],
      checking: false,
      loading: false,
      errorModal: false,
      errorMessage: "",
      birthday: "",
      questions: {
        q1: {
          id: 1,
          answer: "",
          valid: null,
        },
        q2: {
          id: 2,
          answer: "",
          valid: null,
        },
      },
      background: this.$theme.default,
      logoLight: this.$theme.logo.light,
      logoDark: this.$theme.logo.dark,
    };
  },
  async created() {
    window.addEventListener("theme", () => {
      this.background = this.$theme.default;
      this.logoLight = this.$theme.logo.light;
      this.logoDark = this.$theme.logo.dark;
    });
    this.populateDates();
    if (this.$route.params.guid) {
      let res = await getInvitation(this.$route.params.guid);
      if (res.status === 200 && res.user) {
        const u = res.user;
        this.firstName = u.FirstName;
        this.lastName = u.LastName;
        this.birthday = u.DOB;
        this.email = u.Email;
        this.phone = u.PhoneNumber;
        await this.checkEmailAddress();
        await this.checkPhoneNumber();
        // if (this.emailChecksOut && this.phoneChecksOut) {
        //   this.screens.one = false;
        //   this.screens.pVerifyPage = true;
        //   this.sendCodeToUser();
        // }
      }
    }

    this.getQuestions();
  },
  methods: {
    async nextPage() {
      if (
        !this.firstName ||
        !this.lastName ||
        !this.email ||
        !this.phone ||
        !this.agree
      ) {
        this.fnValid = this.firstName.length ? true : false;
        this.lnValid = this.lastName.length ? true : false;
        this.eValid = this.email.length ? true : false;
        this.pValid = this.phone.length ? true : false;
        this.aValid = this.agree ? true : false;
      } else {
        this.phoneRetry = false
        await this.checkPhoneNumber();
        if (this.emailChecksOut && this.phoneChecksOut) {
          this.screens.one = false;
          this.screens.pVerifyPage = true;
          this.sendCodeToUser();
        }
      }
    },
    async nextPageTwo() {
      if (this.phoneVerifyValid) {
        this.screens.pVerifyPage = false;
        this.screens.two = true;
      } else {
        await this.checkCode();
        if (this.phoneVerifyValid) {
          this.screens.pVerifyPage = false;
          this.screens.two = true;
        }
      }
    },
    async accSetupPage() {
      if (!this.password.length || !this.confirmPassword.length) {
        this.passValid = this.password.length ? true : false;
        this.cPassValid = this.confirmPassword.length ? true : false;
      } else if (this.password !== this.confirmPassword) {
        this.cPassValid = false;
        this.cPassMessage = "Passwords do not match.";
      } else if (!this.validPassword) {
        this.passValid = false;
        this.passMessage = "Passwords does not meet requirements.";
      } else {
        this.screens.two = false;
        this.screens.three = true;
      }
    },
    async finish() {
      if (
        !this.questions.q1.answer.length ||
        !this.questions.q2.answer.length
      ) {
        this.questions.q1.valid = this.questions.q1.answer.length
          ? true
          : false;
        this.questions.q2.valid = this.questions.q2.answer.length
          ? true
          : false;
      } else {
        if (this.phoneVerifyValid && this.validEmailAddress) {
          this.creatingAccount = true;
          let res = await newLoanAppUser({
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phone: this.phone,
            password: this.password,
            questions: this.questions,
            dob: this.birthday,
            invitationGUID: this.$route.params.guid || null,
          });
          if (res.status === 200) {
            this.screens.four = true;
            setTimeout(async () => {
              this.checking = true;
              this.loading = true;
              let res = await login(this.email, this.password);
              if (res.status == 200) {
                setTimeout(() => {
                  this.checking = false;
                }, 1000);
                setTimeout(() => {
                  this.$router.push("/");
                }, 3000);
              }
            }, 1000);
          } else {
            this.errorModal = true;
            this.errorMessage = res.message;
          }
        }
      }
    },
    async checkCode() {
      this.phoneVerifyValid = await checkPhoneCode(
        this.phone,
        this.phoneVerifyCode
      );
    },
    async sendCodeToUser() {
      await sendPhoneCode(this.phone);
    },
    async checkEmailAddress() {
      this.phoneChecksOut = false;
      this.validEmailAddress = true;
      let valid = await validEmailAddress(this.email);
      if (!valid) {
        this.validEmailAddress = false;
        this.eValid = false;
        return;
      }
      let res = await checkEmail(this.email);
      this.emailTaken = res;
      if (!res) {
        this.eValid = true;
        this.phoneChecksOut = true;
      } else {
        this.eValid = false;
      }
      return;
    },
    async checkPhoneNumber() {
      let res = await checkPhone(this.phone);
      this.phoneTaken = res;
      if (!res) {
        this.pValid = true;
        this.emailChecksOut = true;
      } else {
        this.pValid = false;
      }
      return;
    },
    async getQuestions() {
      this.defaultQuestions = await getDefaultQuestions();
    },
    async checkPasswordMatch() {
      this.cPassMessage = null;
      if (this.password !== this.confirmPassword) {
        this.cPassValid = false;
        this.cPassMessage = "Passwords do not match.";
      } else {
        this.cPassValid = true;
      }
    },
    async checkPasswordStrength() {
      if (!this.password.length) {
        this.passValid = false;
        this.passMessage = null;
        return;
      }
      this.passMessage = null;
      this.validPassword = await validatePassword(this.password);
      if (this.validPassword) {
        this.passValid = true;
      } else {
        this.passValid = false;
        this.passMessage = "Passwords does not meet requirements.";
      }
    },
    populateDates() {
      let start = new Date().getFullYear();
      this.birthday = `1/1/${start - 16}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.logoHolder {
  display: flex;
  .logo {
    max-width: 150px;
    margin: 10px 40px 20px;
  }
}
.dropdown-toggle {
  width: 100%;
  background: white !important;
  box-shadow: 0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02) !important;
}
.form-group {
  margin-bottom: 0.3rem !important;
}
.form-control {
  color: #323275 !important;
}
.divider {
  border-bottom: 1px solid #adb5bd;
  width: 100%;
  padding: 20px 0 0;
  margin-bottom: 20px;
}
.loginHolder {
  position: absolute;
  top: 0;
  margin: 20% auto;
  left: 0;
  right: 0;
}
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
  opacity: 0;
  margin-top: 40px;
}
.loader-box {
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  position: relative;
  i {
    font-size: 30px;
  }
}
.unlock {
  opacity: 0;
  color: #2dce89;
  animation: scale 1.2s linear 0s forwards;
}
.border-1 {
  position: absolute;
  width: 100px;
  height: 100px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid #2dce89;
}
.border-2 {
  position: absolute;
  width: 100px;
  height: 100px;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid #5e72e4;
}
.spin1 {
  animation: spin3D 1.8s linear 0s infinite;
}
.spin2 {
  animation: spin3D 2.2s linear 0s infinite;
}
.spin3 {
  animation: spin3D 2.2s linear 0s forwards;
}
.opacityChange {
  animation: opacityFade 1.2s linear 0s forwards;
}
.bringOut {
  animation: fadeOut 1.2s linear 0s forwards;
}
.bringIn {
  animation: fadeIn 1.2s linear 0s forwards;
}

.cardHolder {
  opacity: 1;
}

@keyframes scale {
  form {
    font-size: 10px;
    opacity: 0;
  }
  to {
    font-size: 40px;
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes opacityFade {
  form {
    opacity: 1;
  }
  to {
    opacity: 0.2;
  }
}
</style>
